export const UPDATE_FILTER =
  'album-folder-shutterbug-home-filter/UPDATE_FILTER';
export const RESET_FILTER = 'album-folder-shutterbug-home-filter/RESET_FILTER';

export const albumFolderShutterbugHomeFilterUpdate = filter => {
  return { type: UPDATE_FILTER, filter };
};

export const albumFolderShutterbugHomeFilterReset = () => {
  return { type: RESET_FILTER };
};
